<template>
  <main-template ref="main_template">
    <template v-slot:main>

      <div class="page_top">
        <h1 class="title">
          Корзина
        </h1>
      </div>

      <div class="page_content basket" v-show="showPageContent">

        <div class="dd_row">
          <dropdown-filed
              c_style="white"
              :current='order_setup.select_counterparty'
              :list=order_setup.counterparties
              @change="setCounterparty($event)"
          >
          </dropdown-filed>
          <dropdown-filed
              c_style="white"
              :current='order_setup.select_recipient'
              :list=order_setup.recipients
          >
          </dropdown-filed>
          <dropdown-filed
              c_style="white"
              :current='order_setup.select_payment'
              :list=order_setup.payments
          >
          </dropdown-filed>
        </div>

        <div class="select_all">
          <div class="check_all">
            <standart-checkbox :checked="selectAll" @change="check_all_changed($event);">
              <template v-slot:text_content>
                <span>Выбрать все</span>
              </template>
            </standart-checkbox>
          </div>
          <div class="clear" @click="delete_all()">
            <basket-button></basket-button>
            <span>Удалить</span>
          </div>
        </div>

        <basket-products ref="basket_products" @basket_changed="basket_changed_handler()"></basket-products>

        <h3 class="not_avail_title">Товаров нет в наличии</h3>

        <basket-products ref="basket_products_na" :not_available="true" @basket_changed="basket_changed_handler()"></basket-products>

        <div class="total">
          <div class="left">
            <div class="req">
              <span class="value">{{basketData.total_quantity}}</span>
              <span class="description">Кол-во товара</span>
            </div>
            <div class="sep"></div>
            <div class="req">
              <span class="value">{{basketData.total_all_price}}</span>
              <span class="description">Итого стоимость</span>
            </div>
            <div class="sep"></div>
            <div class="req">
              <span class="value b">{{basketData.total_all_bonuses}}</span>
              <span class="description">Ваши бонусы</span>
            </div>
          </div>

          <div class="right">
            <standart-button
                @click="toOrder()"
                style_type="prime" text="Оформить заказ">
            </standart-button>
          </div>
        </div>

      </div>


    </template>
  </main-template>
</template>

<script>
// @ is an alias to /src
import MainTemplate from '@/components/MainTemplate.vue';
import DropdownFiled from "@/components/share/DropdownField";
import BasketButton from "@/components/share/BasketButton";
import StandartCheckbox from "@/components/share/StandartCheckbox";
import StandartButton from "@/components/share/StandartButton";
import BasketProducts from "@/components/basket/BasketProducts";
import axios from "axios";

export default {
  name: 'BasketView',
  components: {
    BasketProducts,
    StandartButton,
    StandartCheckbox,
    BasketButton,
    DropdownFiled,
    MainTemplate,
  },
  data() {
    return{
      selectAll: false,
      order_setup: {
        select_counterparty: {id: 0, title: "Контрагент"},
        select_recipient: {id: 0, title: "Получатель"},
        select_payment: {id: 0, title: "Оплата"},
        counterparties: [],
        recipients: [],
        payments: []
      },
      basketData: {},

      showPageContent : false,
    }
  },
  mounted() {
    this.loadOrderSetupData();
    this.loadData();
  },
  methods : {
    setCounterparty : async function(counterparty_id) {
      await axios.get(window.api_url + "counterparty/set?id="+counterparty_id+"&api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      window.location.reload();
    },
    loadOrderSetupData : async function() {
      let res = await axios.get(window.api_url + "order/setup?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
      this.order_setup.counterparties = res.data.data.counterparties;
      this.order_setup.recipients = res.data.data.recipients;
      this.order_setup.payments = res.data.data.payment_methods;
      this.order_setup.select_counterparty = res.data.data.current_counterparty;
    },
    loadData : async function(update = false) {
      let res = await axios.get(window.api_url + "basket/get?api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");

      this.basketData = res.data.data;

      if(!update) {
        this.$refs.basket_products.basketData = res.data.data.avail_list;
        this.$refs.basket_products_na.basketData = res.data.data.not_avail_list;
      }
      else {
        this.$refs.basket_products.basketData.forEach(function(item, i, arr) {
          if(res.data.data.avail_list.length > 0) {
            res.data.data.avail_list.forEach(function(item2, i2, arr2) {
              if(arr[i].product_id == arr2[i2].product_id) {
                arr[i] = arr2[i2];
              }
            });
          }
        });

        if(res.data.data.not_avail_list.length > 0) {
          let updated_product_ids = new Array();
          this.$refs.basket_products_na.basketData.forEach(function(item, i, arr) {
            res.data.data.not_avail_list.forEach(function(item2, i2, arr2) {
              if(arr[i].product_id == arr2[i2].product_id) {
                arr[i] = arr2[i2];
                updated_product_ids.push(arr[i].product_id)
              }
            });
          });

          let $this = this;
          res.data.data.not_avail_list.forEach(function(item2, i2, arr2) {
            if(!updated_product_ids.includes(arr2[i2].product_id)) {
              $this.$refs.basket_products_na.basketData.push(arr2[i2]);
            }
          });
        }
      }

      this.$refs.main_template.hb_qnt = res.data.data.total_quantity;

      if(this.basketData.list.length > 0) {
        this.showPageContent = true;
      }
    },
    check_all_changed : function(e) {

      if(e) {
        this.$refs.basket_products.basketData.forEach(function(item, i, arr) {
          arr[i].checked = true;
        });
        this.$refs.basket_products_na.basketData.forEach(function(item, i, arr) {
          arr[i].checked = true;
        });

        this.selectAll = true;
      }
      else {
        this.$refs.basket_products.basketData.forEach(function(item, i, arr) {
          arr[i].checked = false;
        });
        this.$refs.basket_products_na.basketData.forEach(function(item, i, arr) {
          arr[i].checked = false;
        });

        this.selectAll = false;
      }
    },

    delete_all : async function() {
      for(let product of this.$refs.basket_products.basketData) {
        if(product.checked) {
          await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity=0&api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
          product.deleted = true;
        }
      }

      /*
      for(let product of this.$refs.basket_products_na.basketData) {
        if(product.checked) {
          await axios.get(window.api_url + "basket/set?id="+product.product_id+"&quantity=0&api=y&auth=IUgioufdoifopowuntyywocjroiOEREOHFihfuiwei");
          product.deleted = true;
        }
      }
      */

      await this.loadData(true);
    },

    basket_changed_handler: function() {
      this.loadData(true);
    },

    toOrder : function() {
      this.$router.push(
          {
            name:'order',
            query: {
              //counterparty: this.order_setup.select_counterparty.id,
              recipient: this.order_setup.select_recipient.id,
              payment: this.order_setup.select_payment.id
            }
          }
      )
    },
  }
}
</script>

<style scoped>
.page_content {

}

.dd_row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.select_all {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.check_all {
  display: flex;
  align-items: center;
}

.select_all .clear {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.select_all .clear span{
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}



.total {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: #FFF;
  box-shadow: 0px 6px 40px 0px rgba(0, 0, 0, 0.07);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.total .left {
  display: flex;
  gap: 20px;
}

.total .left .req {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.total .left .req .value {
  color: var(--Black, #222);
  text-align: left;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.total .left .req .value.b {
  color: var(--Blue, #1B78BC);
}

.total .left .req .description {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.total .left .sep{
  width: 1px;
  background: var(--Border);
}

.not_avail_title {
  display: none;
  margin-top: 30px;
  margin-bottom: 20px;
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .page_top {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 20px;
  }

  .dd_row {
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
  }

  .basket .dropdown_field {
    width: 100%;
  }

  .select_all {
    margin-bottom: 12px;
  }

  .total {
    flex-direction: column;
    gap: 14px;
    padding: 18px 15px;
    margin: 30px -15px -15px -15px;
    border-radius: 8px 8px 0px 0px;
  }

  .total .left{
    flex-direction: column;
    gap: 8px;
  }

  .total .left .sep {
    display: none;
  }

  .total .left .req{
    display: flex;
    flex-direction: row-reverse;
  }

  .total .left .req .value{
    font-size: 14px;
  }

  .total .standart_button {
    width: 100%;
  }

  .not_avail_title {
    display: block;
  }
}
</style>

<style>
.basket .dropdown_field {
  flex: 1;
}

.check_all .text_content {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}

.table .standart-checkbox {
  gap: 0px;
}

.table .standart_button {
  width: 100%;
  height: 38px;
  padding: 10px 0px;
  flex: unset;
}

.total .standart_button {
  width: 212px;
  height: 48px;
  padding: 12px 0px;
}

.select_all .standart-checkbox .custom-checkbox, .table .standart-checkbox .custom-checkbox {
  border-radius: 4px;
  border: 1px solid #DADADA;
  background: var(--BG, #F8F8F8);
}

.select_all .standart-checkbox .custom-checkbox.checked,
.table .standart-checkbox .custom-checkbox.checked {
  border: inherit;
}

.select_all .standart-checkbox .custom-checkbox {
  background: #fff;
}

</style>
